import { takeEvery, put } from "redux-saga/effects";
import { actions } from "redux-store/index";

export function* createMerchantSaga() {
  yield takeEvery(actions.postMerchants.success.type, function* () {
    yield put(actions.setIsCreateMerchantDialogOpen(false));
  });
  yield takeEvery(actions.putMerchantsByMerchantId.success.type, function* () {
    yield put(actions.setIsCreateMerchantBannerDialogOpen(false));
  });
  yield takeEvery(actions.putMerchantsByMerchantId.success.type, function* () {
    yield put(actions.setIsCreateDefaultEventDialogOpen(false));
  });
}

export function* updateMerchantUsagesSaga() {
  yield takeEvery(actions.postMerchantsEventsByMerchantId.success, function* (
    action,
  ) {
    const { merchantId } = action.payload.prepareParams;
    yield put(
      actions.getMerchantsUsagesByMerchantId.request({
        merchantId,
      }),
    );
  });
  yield takeEvery(actions.postNotifications.success, function* (action) {
    const { merchantId } = action.payload.prepareParams;
    yield put(
      actions.getMerchantsUsagesByMerchantId.request({
        merchantId,
      }),
    );
  });
}
